export function isProfessionalActive(professional) {
  if (!professional || professional.status === undefined || professional.status === null) {
    return true
  }

  return professional.status === 1
    || professional.status === true
    || professional.status === "1"
}

export function professionalStatusLabel(professional) {
  return isProfessionalActive(professional) ? "Ativo" : "Inativo"
}

export function professionalFilterLabel(professional) {
  const name = professional?.name || professional?.label || ""
  if (isProfessionalActive(professional)) {
    return name
  }

  return `${name} (Inativo)`
}

export function mapProfessionalOption(professional) {
  return {
    id: professional.id,
    name: professional.name,
    status: professional.status,
    label: `${String(professional.id)} - ${professionalFilterLabel(professional)}`,
  }
}

export function filterActiveProfessionals(professionals) {
  if (!Array.isArray(professionals)) {
    return []
  }

  return professionals.filter((professional) => (
    professional
    && professional.status !== undefined
    && professional.status !== null
    && isProfessionalActive(professional)
  ))
}
